import { Modal } from '@ui';
import type { FC } from 'react';
import { observer } from 'mobx-react';
import useWindowSize from '@customHooks/useWindowSize';
import AuthForm from '@components/AuthForm';
import { useStores } from '@root/src/stores';

const AuthModals: FC = observer(() => {
  const { modalsStore } = useStores();
  const { changeAuthModalState, changeLoginErrorMsg, showLoginModal } =
    modalsStore;

  const { viewportHeight } = useWindowSize();

  const onClosePopup = (): void => {
    changeLoginErrorMsg('');
    changeAuthModalState();
  };

  if (!viewportHeight) {
    return null;
  }
  return (
    <Modal
      framed
      open={showLoginModal}
      popupProps={{ closeOnDocumentClick: false }}
      withoutCross
      size='fromMd:w-[480px] fromMd:min-w-[480px] fromMd:min-h-[383px]'
      className='flex flex-col items-center justify-center'
      placementMobile='fullscreen'
      onClose={onClosePopup}
    >
      {(closeModal: () => void) => <AuthForm closeModal={closeModal} />}
    </Modal>
  );
});

export default AuthModals;
